import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "my-3" }
const _hoisted_4 = { for: "status-pattern" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { ref } from 'vue';
import { formatDateTimeStringToIso } from '@/utils/date-utils';
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
} from 'bootstrap-vue-next';
import { OrganizationType } from '@/gql/graphql';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import InviteCreate from '@/components/invite/InviteCreate.vue';
import InvitesList from '@/components/invite/InvitesList.vue';
import OrganizationPicker from '@/components/organization/OrganizationPicker.vue';

// --- Component references ---

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminInvitesListView',
  setup(__props) {

const InvitesListRef = ref<InstanceType<typeof InvitesList>>();

// New invite state
const newInviteOrg = ref<OrganizationType | null>(null);
const showNewInviteModal = ref(false);

// Filtering and paging state
const inviteId = ref<number | null>(null);
const userIdInvited = ref<number | null>(null);
const userIdInviter = ref<number | null>(null);
const organizationId = ref<number | null>(null);
const userRole = ref<string | null>(null);
const statusPattern = ref('');
const emailPattern = ref('');

const dateCreatedAfter = ref<string | null>(null);
const dateCreatedBefore = ref<string | null>(null);
const timeCreatedAfter = ref<string | null>(null);
const timeCreatedBefore = ref<string | null>(null);
const dateTimeCreatedAfter = ref<string | null>(null);
const dateTimeCreatedBefore = ref<string | null>(null);

const dateExpiredAfter = ref<string | null>(null);
const dateExpiredBefore = ref<string | null>(null);
const timeExpiredAfter = ref<string | null>(null);
const timeExpiredBefore = ref<string | null>(null);
const dateTimeExpiredAfter = ref<string | null>(null);
const dateTimeExpiredBefore = ref<string | null>(null);

const dateAcceptedAfter = ref<string | null>(null);
const dateAcceptedBefore = ref<string | null>(null);
const timeAcceptedAfter = ref<string | null>(null);
const timeAcceptedBefore = ref<string | null>(null);
const dateTimeAcceptedAfter = ref<string | null>(null);
const dateTimeAcceptedBefore = ref<string | null>(null);

const dateRevokedAfter = ref<string | null>(null);
const dateRevokedBefore = ref<string | null>(null);
const timeRevokedAfter = ref<string | null>(null);
const timeRevokedBefore = ref<string | null>(null);
const dateTimeRevokedAfter = ref<string | null>(null);
const dateTimeRevokedBefore = ref<string | null>(null);

const dateCanceledAfter = ref<string | null>(null);
const dateCanceledBefore = ref<string | null>(null);
const timeCanceledAfter = ref<string | null>(null);
const timeCanceledBefore = ref<string | null>(null);
const dateTimeCanceledAfter = ref<string | null>(null);
const dateTimeCanceledBefore = ref<string | null>(null);

function clearFilter() {
  inviteId.value = null;
  userIdInviter.value = null;
  userIdInvited.value = null;
  organizationId.value = null;
  userRole.value = '';
  statusPattern.value = '';
  emailPattern.value = '';

  dateCreatedBefore.value = null;
  timeCreatedBefore.value = null;
  dateTimeCreatedBefore.value = null;

  dateCreatedAfter.value = null;
  timeCreatedAfter.value = null;
  dateTimeCreatedAfter.value = null;

  dateCanceledBefore.value = null;
  timeCanceledBefore.value = null;
  dateTimeCanceledBefore.value = null;

  dateCanceledAfter.value = null;
  timeCanceledAfter.value = null;
  dateTimeCanceledAfter.value = null;

  dateAcceptedBefore.value = null;
  timeAcceptedBefore.value = null;
  dateTimeAcceptedBefore.value = null;

  dateAcceptedAfter.value = null;
  timeAcceptedAfter.value = null;
  dateTimeAcceptedAfter.value = null;

  dateRevokedBefore.value = null;
  timeRevokedBefore.value = null;
  dateTimeRevokedBefore.value = null;

  dateRevokedAfter.value = null;
  timeRevokedAfter.value = null;
  dateTimeRevokedAfter.value = null;

  dateExpiredBefore.value = null;
  timeExpiredBefore.value = null;
  dateTimeExpiredBefore.value = null;

  dateExpiredAfter.value = null;
  timeExpiredAfter.value = null;
  dateTimeExpiredAfter.value = null;

  requestSearch();
}

function requestSearch() {
  // check integer values are integer values
  if (!Number.isInteger(inviteId.value)) {
    console.warn('Invalid task ID. Resetting to null.');
    inviteId.value = null;
  }
  if (!Number.isInteger(userIdInvited.value)) {
    console.warn('Invalid parent ID. Resetting to null.');
    userIdInvited.value = null;
  }
  if (!Number.isInteger(userIdInviter.value)) {
    console.warn('Invalid user ID. Resetting to null.');
    userIdInviter.value = null;
  }
  if (!Number.isInteger(organizationId.value)) {
    console.warn('Invalid organization ID. Resetting to null.');
    organizationId.value = null;
  }

  // convert date and time to dateTime object (current timezone)
  dateTimeCreatedBefore.value = formatDateTimeStringToIso(
    dateCreatedBefore.value,
    timeCreatedBefore.value
  );
  dateTimeCreatedAfter.value = formatDateTimeStringToIso(
    dateCreatedAfter.value,
    timeCreatedAfter.value
  );
  dateTimeAcceptedBefore.value = formatDateTimeStringToIso(
    dateAcceptedBefore.value,
    timeAcceptedBefore.value
  );
  dateTimeAcceptedAfter.value = formatDateTimeStringToIso(
    dateAcceptedAfter.value,
    timeAcceptedAfter.value
  );
  dateTimeCanceledBefore.value = formatDateTimeStringToIso(
    dateCanceledBefore.value,
    timeCanceledBefore.value
  );
  dateTimeCanceledAfter.value = formatDateTimeStringToIso(
    dateCanceledAfter.value,
    timeCanceledAfter.value
  );
  dateTimeExpiredBefore.value = formatDateTimeStringToIso(
    dateExpiredBefore.value,
    timeExpiredBefore.value
  );
  dateTimeExpiredAfter.value = formatDateTimeStringToIso(
    dateExpiredAfter.value,
    timeExpiredAfter.value
  );
  dateTimeRevokedBefore.value = formatDateTimeStringToIso(
    dateRevokedBefore.value,
    timeRevokedBefore.value
  );
  dateTimeRevokedAfter.value = formatDateTimeStringToIso(
    dateRevokedAfter.value,
    timeRevokedAfter.value
  );

  // refetch the tasks with updated filters
  InvitesListRef.value?.requestSearch();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, [
      _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'list-check'] }),
      _cache[31] || (_cache[31] = _createTextVNode(" Invites Management ", -1))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("h3", null, [
        _createVNode(_unref(FontAwesomeIcon), {
          icon: ['fas', 'user-plus'],
          class: "me-2"
        }),
        _cache[32] || (_cache[32] = _createTextVNode(" Create Invite ", -1))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(OrganizationPicker, {
          modelValue: newInviteOrg.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newInviteOrg).value = $event)),
          class: "mb-2",
          label: "Select organization to invite user to",
          allowNullOrganization: false,
          includeOwnerFullName: true,
          includeOwnerEmail: true,
          includeCountryCode: true
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(BButton), {
          variant: "outline-dark",
          disabled: !newInviteOrg.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showNewInviteModal.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: ['fas', 'plus'],
              class: "me-2"
            }),
            _cache[33] || (_cache[33] = _createTextVNode(" Invite New User ", -1))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("h3", null, [
        _createVNode(_unref(FontAwesomeIcon), {
          icon: ['fas', 'envelope'],
          class: "me-2"
        }),
        _cache[34] || (_cache[34] = _createTextVNode(" List of Invites ", -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(BForm), {
          class: "d-flex flex-row align-items-end flex-wrap gap-2",
          onSubmit: _withModifiers(requestSearch, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BFormGroup), {
              label: "Invite ID",
              "label-for": "invite-id"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "invite-id",
                  type: "number",
                  modelValue: inviteId.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inviteId).value = $event)),
                  modelModifiers: { number: true },
                  placeholder: "Invite ID"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "User ID Invited",
              "label-for": "user-id-invited"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "user-id-invited",
                  type: "number",
                  modelValue: userIdInvited.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userIdInvited).value = $event)),
                  modelModifiers: { number: true },
                  placeholder: "User ID Invited"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "User ID Inviter",
              "label-for": "user-id-inviter"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "user-id-inviter",
                  type: "number",
                  modelValue: userIdInviter.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userIdInviter).value = $event)),
                  modelModifiers: { number: true },
                  placeholder: "User ID Inviter"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Organization ID",
              "label-for": "organization-id"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "organization-id",
                  type: "number",
                  modelValue: organizationId.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((organizationId).value = $event)),
                  modelModifiers: { number: true },
                  placeholder: "Organization ID"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "User Role",
              "label-for": "user-role"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "user-role",
                  type: "text",
                  modelValue: userRole.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((userRole).value = $event)),
                  placeholder: "e.g. admin, member"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), null, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_4, [
                  _cache[35] || (_cache[35] = _createTextVNode(" Status pattern ", -1)),
                  _createVNode(_unref(FontAwesomeIcon), {
                    id: "status-pattern-tooltip-icon",
                    icon: "question-circle",
                    class: "ms-1 text-secondary"
                  })
                ]),
                _createVNode(_unref(BFormInput), {
                  id: "status-pattern",
                  type: "text",
                  modelValue: statusPattern.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((statusPattern).value = $event)),
                  placeholder: "e.g. pending, accepted, canceled, revoked"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Email Pattern",
              "label-for": "email-pattern"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "email-pattern",
                  type: "text",
                  modelValue: emailPattern.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((emailPattern).value = $event)),
                  placeholder: "e.g. user@example.com or user%@example.com"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date created after",
              "label-for": "date-created-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-created-after",
                  type: "date",
                  modelValue: dateCreatedAfter.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dateCreatedAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time created after",
              "label-for": "time-created-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-created-after",
                  type: "time",
                  modelValue: timeCreatedAfter.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((timeCreatedAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date created before",
              "label-for": "date-created-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-created-before",
                  type: "date",
                  modelValue: dateCreatedBefore.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dateCreatedBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time created before",
              "label-for": "time-created-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-created-before",
                  type: "time",
                  modelValue: timeCreatedBefore.value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((timeCreatedBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date accepted after",
              "label-for": "date-accepted-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-accepted-after",
                  type: "date",
                  modelValue: dateAcceptedAfter.value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dateAcceptedAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time accepted after",
              "label-for": "time-accepted-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-accepted-after",
                  type: "time",
                  modelValue: timeAcceptedAfter.value,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((timeAcceptedAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date accepted before",
              "label-for": "date-accepted-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-accepted-before",
                  type: "date",
                  modelValue: dateAcceptedBefore.value,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dateAcceptedBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time accepted before",
              "label-for": "time-accepted-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-accepted-before",
                  type: "time",
                  modelValue: timeAcceptedBefore.value,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((timeAcceptedBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date canceled after",
              "label-for": "date-canceled-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-canceled-after",
                  type: "date",
                  modelValue: dateCanceledAfter.value,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((dateCanceledAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time canceled after",
              "label-for": "time-canceled-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-canceled-after",
                  type: "time",
                  modelValue: timeCanceledAfter.value,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((timeCanceledAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date canceled before",
              "label-for": "date-canceled-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-canceled-before",
                  type: "date",
                  modelValue: dateCanceledBefore.value,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((dateCanceledBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time canceled before",
              "label-for": "time-canceled-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-canceled-before",
                  type: "time",
                  modelValue: timeCanceledBefore.value,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((timeCanceledBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date revoked after",
              "label-for": "date-revoked-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-revoked-after",
                  type: "date",
                  modelValue: dateRevokedAfter.value,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((dateRevokedAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time revoked after",
              "label-for": "time-revoked-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-revoked-after",
                  type: "time",
                  modelValue: timeRevokedAfter.value,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((timeRevokedAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date revoked before",
              "label-for": "date-revoked-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-revoked-before",
                  type: "date",
                  modelValue: dateRevokedBefore.value,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((dateRevokedBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time revoked before",
              "label-for": "time-revoked-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-revoked-before",
                  type: "time",
                  modelValue: timeRevokedBefore.value,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((timeRevokedBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date expired after",
              "label-for": "date-expired-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-expired-after",
                  type: "date",
                  modelValue: dateExpiredAfter.value,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((dateExpiredAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time expired after",
              "label-for": "time-expired-after"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-expired-after",
                  type: "time",
                  modelValue: timeExpiredAfter.value,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((timeExpiredAfter).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Date expired before",
              "label-for": "date-expired-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "date-expired-before",
                  type: "date",
                  modelValue: dateExpiredBefore.value,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((dateExpiredBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BFormGroup), {
              label: "Time expired before",
              "label-for": "time-expired-before"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "time-expired-before",
                  type: "time",
                  modelValue: timeExpiredBefore.value,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((timeExpiredBefore).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BButton), {
              variant: "outline-secondary",
              onClick: clearFilter
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FontAwesomeIcon), {
                  icon: "trash",
                  class: "me-1"
                }),
                _cache[36] || (_cache[36] = _createTextVNode(" Clear filter ", -1))
              ]),
              _: 1
            }),
            _createVNode(_unref(BButton), {
              variant: "outline-dark",
              type: "submit",
              disabled: InvitesListRef.value?.loadingInvitesQuery
            }, {
              default: _withCtx(() => [
                (InvitesListRef.value?.loadingInvitesQuery)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_unref(BSpinner), {
                        small: "",
                        label: ""
                      }),
                      _cache[37] || (_cache[37] = _createTextVNode(" Searching ", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_unref(FontAwesomeIcon), {
                        icon: "magnifying-glass",
                        class: "me-1"
                      }),
                      _cache[38] || (_cache[38] = _createTextVNode(" Search ", -1))
                    ]))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _createVNode(InvitesList, {
        ref_key: "InvitesListRef",
        ref: InvitesListRef,
        invitedUserId: userIdInvited.value,
        inviterUserId: userIdInviter.value,
        organizationId: organizationId.value,
        userRole: userRole.value,
        statusPattern: statusPattern.value,
        emailPattern: emailPattern.value,
        showStatus: true,
        adminView: true
      }, null, 8, ["invitedUserId", "inviterUserId", "organizationId", "userRole", "statusPattern", "emailPattern"]),
      (newInviteOrg.value)
        ? (_openBlock(), _createBlock(InviteCreate, {
            key: 0,
            organization: newInviteOrg.value,
            adminView: true,
            show: showNewInviteModal.value,
            onClose: _cache[29] || (_cache[29] = ($event: any) => (showNewInviteModal.value = false)),
            onSuccess: _cache[30] || (_cache[30] = ($event: any) => (requestSearch()))
          }, null, 8, ["organization", "show"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})